import publicApiCall from "../utils/axiosCall";

export const contactUsFormCall = (data) => {
  return publicApiCall.postPublic("app/contact-us", data);
};
